// @flow
import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import { format, isPast } from 'date-fns'
import Layout from '../layout'
import Button from '../components/button'
import ShowDate from '../components/date'
import Icon from '../components/icon'
import commonStyles from '../common.module.css'

function CallForSubmissionsPage() {
  const data = useStaticQuery(graphql`
    query CallForSubmissions {
      site {
        siteMetadata {
          dates {
            speakerRegistrationBy
            submitAbstractBy
            notifyAbstractAcceptance
          }
        }
      }
    }
  `)
  const { dates } = data.site.siteMetadata
  return (
    <Layout>
      <Helmet>
        <title>Call for Submissions</title>
      </Helmet>
      <h1>Call for Submissions</h1>
      <p>
        We welcome you to take part in a conference that strives to present and
        discuss the plurality of approaches to the scholarly publishing and
        assessment (metrics) and new trends in the scholarly publishing area.
        Themes of the conference include the following:
      </p>
      <ul>
        <li>
          open scholarship (in relation to Plan S initiative) including open
          access to publications and research data, open educational materials,
          open peer review
        </li>
        <li>
          digital OA repositories (including next generation repositories)
        </li>
        <li>
          personal data protection, copyright and licencing (Creative Commons
          licences)
        </li>
        <li>
          research assessment (bibliometrics, altmetrics, next generation
          metrics)
        </li>
        <li>
          digital scholarly publishing (interactive digital publications,
          multimedia content, semantics, identifiers)
        </li>
        <li>
          editorial practice and ethical questions (editorial policy, standards
          of editorial work, plagiarism detection, peer- review process,
          authorship and contributorship)
        </li>
      </ul>
      <p>
        The organisers of the PUBMET2019 conference invite you to submit
        extended abstract (600-1200 words plus no more than 8 references). All
        submissions should be written in English. The authors should use the
        template available here:
      </p>
      <div className={commonStyles.center}>
        {isPast(dates.submitAbstractBy[dates.submitAbstractBy.length - 1]) ? (
          <p>
            The deadline to submit an abstract has passed.{' '}
            <Link to="/contact-us">Contact us</Link> for inquiries about the
            submissions.
          </p>
        ) : (
          <>
            <p>
              <Button
                as="a"
                href="https://res.cloudinary.com/pubmet/raw/upload/v1/pubmet2019-submission-template.docx"
                download
              >
                <Icon role="img" id="file-download" size={24} />
                <span>Template</span>
              </Button>
            </p>
            <p>
              Submission should be made using the{' '}
              <a href="https://easychair.org/conferences/?conf=pubmet2019">
                <b>EasyChair system</b>
              </a>
              .
            </p>
          </>
        )}
      </div>
      <p>
        Your abstract will undergo a double blind peer review by the
        international programme committee within two to three weeks after its
        receipt. Results of the abstract review will be sent to the author
        within three weeks of submission. Acceptance or rejections of the paper
        will be sent to you with reviewer comments. In order to be eligible for
        Early Bird rates the abstract should be submitted well before the
        submission deadline. Accepted abstracts will be published in the
        PUBMET2019 Book of Abstracts. Full paper submission is optional and
        accepted papers will be published in the PUBMET2019 Conference
        Proceedings.
      </p>

      <h2>Requirements</h2>
      <p>
        Presenters of accepted abstracts must register for the conference by
        {format(dates.speakerRegistrationBy, 'D MMMM YYYY')}, otherwise they
        will not be included in the programme. Each presenting author is
        responsible for his/her registration fee(s) as well as travel and
        accommodation costs. Presenters who are unable to attend the PUBMET2019
        conference can arrange for a co-author to present.
      </p>

      <h2>Important dates</h2>
      <ul>
        <li>
          <b>Online abstract submission deadline</b>:{' '}
          <ShowDate
            date={dates.submitAbstractBy}
            pastText="The deadline has passed."
          />
        </li>
        <li>
          <b>Abstract acceptance notification</b>:{' '}
          <ShowDate date={dates.notifyAbstractAcceptance} />
        </li>
        <li>
          <b>Accepted speakers must register by</b>:{' '}
          <ShowDate date={dates.speakerRegistrationBy} />
        </li>
      </ul>
    </Layout>
  )
}

export default CallForSubmissionsPage
